import { Check, Circle } from "lucide-react";
import { useI18n, sopTitle } from "@/lib/i18n";

export default function SopDocket({ stages, counts, selected, onSelect, analyzed, summaries = [] }) {
  const { t } = useI18n();
  const isDone = (s) => {
    if (counts[s.code] > 0) return true;
    if (summaries.includes(s.code)) return true; // stage analyzed by AI
    if (analyzed && !s.category) return true; // analytical stages resolved by report
    return false;
  };
  const done = stages.filter(isDone).length;
  const pct = stages.length ? Math.round((done / stages.length) * 100) : 0;

  return (
    <div className="flex h-full flex-col">
      <div className="px-4 pt-5 pb-4 border-b border-zinc-800">
        <p className="font-mono-ui text-[10px] uppercase tracking-[0.18em] text-zinc-500">{t("docket.title")}</p>
        <div className="mt-3 flex items-center justify-between">
          <span className="font-serif-display text-2xl font-light text-zinc-100">{pct}%</span>
          <span className="font-mono-ui text-[11px] text-zinc-500">{t("docket.count", { done, total: stages.length })}</span>
        </div>
        <div className="mt-2 h-1 w-full rounded-full bg-zinc-800 overflow-hidden">
          <div className="h-full bg-[#d4af37] transition-[width] duration-500" style={{ width: `${pct}%` }} />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-3 space-y-0.5">
        {stages.map((s) => {
          const active = selected === s.code;
          const finished = isDone(s);
          return (
            <button
              key={s.code}
              data-testid={`sop-step-${s.code}`}
              onClick={() => onSelect(active ? null : s.code)}
              className={`w-full text-left rounded-md px-3 py-2.5 border-l-2 transition-colors ${
                active
                  ? "bg-zinc-800/60 border-[#d4af37] text-zinc-100"
                  : "border-transparent text-zinc-500 hover:bg-zinc-800/30 hover:text-zinc-300"
              }`}
            >
              <div className="flex items-center gap-2">
                {finished ? (
                  <Check className="h-3.5 w-3.5 text-emerald-400 shrink-0" strokeWidth={2.5} />
                ) : (
                  <Circle className="h-3.5 w-3.5 text-zinc-700 shrink-0" strokeWidth={1.5} />
                )}
                <span className="font-mono-ui text-[10px] tracking-wider text-zinc-500">{s.code}</span>
                {counts[s.code] > 0 && (
                  <span className="ml-auto font-mono-ui text-[10px] text-zinc-400 bg-zinc-800 rounded px-1.5">
                    {counts[s.code]}
                  </span>
                )}
              </div>
              <p className="mt-1 text-[13px] leading-snug">{sopTitle(t, s)}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
